import { Collection } from '@/state/Collection';
import { _ACHIEVEMENTS } from "@/state";
import { _TENANT } from "@/state";

import { AchievementsRoutes } from '@/repository/resources';
const { GetAllAchievements } = AchievementsRoutes;

// NOTE: No show or update

// Export this module
export default {
	namespaced: true,
	state: {
		all: Collection.stateDefaults(),
		_all: new Collection({ statePath: 'achievements.all' })
	},
	actions: {

		async index({ commit }, args) {
			if (_TENANT().blocked_apps.includes('achievements')) return;
			try {
				let { page, per_page } = Object.assign({}, args)
				let res = await GetAllAchievements({ page, per_page });
				commit('SET_ACHIEVEMENTS_LIST', res.data);
			}
			catch (error) {
				console.error('Achievements could not be indexed.', error);
				throw error;
			}
		},

		async indexNextPage({ commit }) {
			if (_TENANT().blocked_apps.includes('achievements')) return;
			try {
				if (_ACHIEVEMENTS().pagination.isLastPage()) {
					return;
				}
				let res = await GetAllAchievements({ page: _ACHIEVEMENTS().pagination.nextPage() })
				commit('APPEND_MULTIPLE_ACHIEVEMENTS_TO_LIST', res.data);
			}
			catch (error) {
				console.error('Next page of achievement could not be indexed.', error);
				throw error;
			}
		}

	},
	mutations: {
		SET_ACHIEVEMENTS_LIST(state, data) {
			state._all.items.set(data).commitToState()
		},
		APPEND_MULTIPLE_ACHIEVEMENTS_TO_LIST(state, objs) {
			state._all.items.appends(objs).commitToState();
		},
		PREPEND_SINGLE_ACHIEVEMENT_TO_LIST(state, obj) {
			state._all.items.prepend(obj).commitToState();
		},
		DELETE_ACHIEVEMENT(state, obj) {
			state._all.items.deleteItem(obj).commitToState();
		},
	}
}